/**
 * DNB Eufemia Defaults
 *
 */

export const LOCALE = 'nb-NO'
export const CURRENCY = 'NOK'
export const CURRENCY_DISPLAY = 'narrowSymbol' as const // code, name, symbol, narrowSymbol
export const CURRENCY_FALLBACK_DISPLAY = 'code' as const // code, name, symbol, narrowSymbol
export const COUNTRY = 'NO' // ISO 3166-1 alpha-2
